import angular from 'angular';
import {asyncDigest} from '@/angular/libs/angular-await';
import {NOTIFICATION_TYPE_ERROR} from "@/vue/store/modules/notifications";

angular.module('vrm.core')
    .controller('ResetPasswordController', ResetPasswordController);

/** @ngInject */
function ResetPasswordController($scope, $stateParams, ResetPasswordService, vrmNotificationsService, locale) {
    // Update model with parameters from url
    ResetPasswordService.formModel.password_reset_hash = $stateParams.password_reset_hash;

    // bind model
    $scope.formModel = ResetPasswordService.formModel;

    // User info for validating password, empty because we cannot retrieve it without
    // logging in so we rely on the backend validation.
    $scope.userInfo = { name: '', email: '' };

    $scope.mfaRequired = false;
    $scope.mfaMode = 'password';

    let passwordRequirementsNotificationId;

    $scope.doResetPassword = asyncDigest($scope, async () => {
        // Remove password requirements notification if it has been fixed
        if ($scope.resetForm.password.$valid) {
            vrmNotificationsService.remove(passwordRequirementsNotificationId);
        }

        if (!$scope.resetForm.password.$valid) {
            // Show the password requirements if password invalid
            passwordRequirementsNotificationId = vrmNotificationsService.add({
                type: NOTIFICATION_TYPE_ERROR,
                title: locale.getString('general.password_requirements'),
                message: `<ul>${locale.getString('general.password_consists')}` +
                    `<li>${locale.getString('general.password_requirement_minimum')}</li>` +
                    `<li>${locale.getString('general.password_requirement_alphanumeric')}</li>` +
                    `<li>${locale.getString('general.password_requirement_special_character')}</li>` +
                    `<li>${locale.getString('general.password_requirement_email')}</li>` +
                    `<li>${locale.getString('general.password_requirement_name')}</li></ul>`,
                lifespan: 0, // Don't expire, give user time to change their password
            });
            return;
        } else if (!$scope.resetForm.$valid) {
            return;
        }

        const result = await ResetPasswordService.updatePasswordRequest();
        if (result.success) {
            $scope.requestComplete = true;
        } else if (result.mfaRequired) {
            $scope.mfaRequired = true;
            $scope.mfaMode = result.mfaMode;
            // When first extending the form, make it pristine again so the validation doesnt show
            if (!result.mfaFailure) {
                if ($scope.resetForm) {
                    $scope.resetForm.$setPristine();
                    $scope.resetForm.$setUntouched();
                }
            }
        }
        return result.success;
    });
}
